export default {
  install(app) {
  }
}
